import { useEffect, useState } from 'react';
import styles from './index.module.scss';

/**
 * Set Truspilot widget height without SSR mismatch warning.
 */
export const useTrustpilotHeight = (): string => {
  const [height, setHeight] = useState('60px');

  const { smallBreakpoint } = styles;
  useEffect(() => {
    if (window.innerWidth < parseInt(smallBreakpoint, 10)) {
      setHeight('90px');
    }
  }, [smallBreakpoint]);

  return height;
};
